
































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { CustomerModule } from '@/store/Customers/CustomerModule';
import PageNames from '@/router/PageNames';
import CustomerAccountCreate from '@/components/Customers/Customers/CustomerAccountCreate.vue';
import AccountState from '@/components/Accounts/Shared/AccountState.vue';
import DepositAccount from '@/models/Accounts/DepositAccounts/DepositAccount';
import PermissionUtils from '@/lib/permissionUtils';
import ProductType from "@/models/Products/ProductType";

@Component({ name: 'CustomerDetails', components: { CustomerAccountCreate, AccountState } } )
export default class extends SaascadaVue {

    @Prop({ required: true })
    customerId: string;

    PermissionUtils = PermissionUtils;
    headers = [
        { text: this.$t('pageText.customers.fields.name'), width: "40%" },
        { text: this.$t('pageText.customers.fields.productIssue'), width: "40%" },
        { text: this.$t('pageText.customers.fields.state'), width: "20%" }
    ];
    customerAccountsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.customerAccountsPage = +page;
        }
    }

    async beforeMount() {
        await CustomerModule.getAccountsForCustomer({ id: this.customerId, pageNumber: this.customerAccountsPage });
    }

    @Watch('customerAccountsPage')
    async onCustomerAccountsPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.customerAccountsPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.customerAccountsPage}` } });
        }
        // Get new accounts
        await CustomerModule.getAccountsForCustomer({ id: this.customerId, pageNumber: this.customerAccountsPage });
    }

    get loading() {
        return CustomerModule.loadingAccounts;
    }

    get accounts() {
        return CustomerModule.accounts;
    }

    get totalDepositAccountsPages() {
        return CustomerModule.totalDepositAccountsPages;
    }

    get pageSize() {
        return CustomerModule.pageSize;
    }

    get customer() {
        return CustomerModule.customer;
    }

    get accountHolders() {
        if (CustomerModule.customer.entityIdentifier) {
            // Organisation is always a single entity
            return [ CustomerModule.customer.entityIdentifier ]
        }
        // Customer can be multiple so comes back as plural "identifiers"
        return CustomerModule.customer.entityIdentifiers;
    }

    async navigateToAccount(account: DepositAccount) {
        const accountPageName = account.productType === ProductType.Deposit ? PageNames.DepositAccount : PageNames.LendingAccount;
        this.$router.push({ name: accountPageName, params: { id: account.id } });
    }

}
